import cn from 'classnames';
import React, { FC, memo } from 'react';

import SliderMUI, { SliderProps } from '@mui/material/Slider';

import { SliderVariant } from '@constants/common/ui.constants';

import useStyles from './styles.module';

type Props = SliderProps & {
  className?: string;
  isRangeSlider?: boolean;
  variant?: SliderVariant;
};

const Slider: FC<Props> = ({
  className = '',
  disabled,
  valueLabelDisplay,
  variant = SliderVariant.Primary,
  isRangeSlider = false,
  value,
  onChange,
  ...props
}) => {
  const { classes } = useStyles({ variant });

  return (
    <>
      {isRangeSlider ? (
        <SliderMUI
          className={cn(
            classes.sliderWrap,
            { [classes.disabled]: disabled },
            className,
          )}
          value={value}
          onChange={onChange}
          valueLabelDisplay="auto"
          disabled={disabled}
          {...props}
        />
      ) : (
        <SliderMUI
          className={cn(
            classes.sliderWrap,
            { [classes.disabled]: disabled },
            className,
          )}
          valueLabelDisplay={valueLabelDisplay || 'auto'}
          aria-label="pretto slider"
          disabled={disabled}
          value={value}
          onChange={onChange}
          marks
          {...props}
        />
      )}
    </>
  );
};

export default memo(Slider);
